import React from 'react';

class PlanningGuideThumb extends React.Component {
 handleClick(e) {
    e.preventDefault()
    this.props.handleOnClick(this.props.data)
    e.preventDefault()
    $.getJSON(`/leave_plan_guides/${this.props.data.id}/fetch_details`, (data) => {
      gon.company_variables = {...gon.company_variables, ...data.statutory_substitutions_options}
      this.props.handleOnClick(this.props.data, data.description)
    })
 }

  taskCount() {
    return this.props.data.timeline_items.length
  }

  allTasksAdded() {
    const timeline_items = this.props.data.timeline_items
    if (timeline_items) {
      let data = $.map(timeline_items, (item) => {
        return item.added_to_leave_plan
      })
      if ($.inArray(false, data) == -1 && this.props.data.added_to_leave_plan) {
        return ''
      } else {
        return 'all-not-added'
      }
    }
  }

  renderTaskCount() {
    if (this.taskCount() > 0) {
      return <TasksCounter tasksCount={this.taskCount()} />
    }
  }

  render() {
    const divStyle = {backgroundImage: 'url('+ this.props.data.image_url + ')'}
    return (
      <div
        className='col-md-11 planning-guide-item tasks-counter'
        onClick={this.handleClick}
      >
        <div className='plan-guide-img' style={divStyle} />
        <div className='plan-guide-content'>
          <h3 className={`guide-title ${this.allTasksAdded()}`}>
            { this.props.data.title }
            { this.renderTaskCount() }
          </h3>
          <p className='summary'>
            {this.props.data.summary}
          </p>
          <div className='read-more'>
            <a href='' onClick={this.handleClick}>
              READ MORE
            </a>
          </div>
        </div>
      </div>
    )
  }
}

export default PlanningGuideThumb
